import React, { Component } from 'react';
import ReactCustomFlagSelect from './ReactCustomFlagSelect';
import { ToastContainer, toast } from 'react-toastify';
import LotDetails from './LotDetails';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
// import 'moment-timezone';
import { countryCode } from './static';
import './Event.css';
import gpsIcon from "./img/gps.png";
import logoImg from "./img/customers/3-points.png";
import notAllowed from "./img/exclamation-mark.png";

export default class App extends Component {

  constructor(props){
    super(props);
    this.initForm = this.initForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAreaCode = this.handleAreaCode.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hours = [];
    this.mins = [];
    const urlParams = new URLSearchParams(window.location.search);
    if(process.env.REACT_APP_ENVIRONMENT === 'STAGING' && urlParams && urlParams.get('env') && urlParams.get('env') === 'dev'){
      this.baseUrl = process.env.REACT_APP_DEV_API_URL;
      this.stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY;
    }else{
      this.baseUrl = process.env.REACT_APP_API_URL;
      this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    }
    this.initialState =  {
      availableDates: {},
      selectedDates: [],
      loading: false,
      booked: false,
      fields: {
        areaCode: 1,
        email: ''
      },
      errors: {}
    }
    this.resetState = {
      booked: true,
      selectedDates: [],
      bookingID: null,
      convenienceFee: null,
      end: null,
      errors: {},
      fields: {areaCode: 1, email: '', license_plate: '', mobile: '', zip: '', cardholder_name: ''},
      loading: false,
      parkingFee: null,
      totalFee: null,
      surchargeFee: null,
      salesTaxFee: null,
      transactionFee: null
    }
    this.state = this.initialState;
  }

  componentDidMount(){
    const defer = () =>  {
      if (window.Stripe) {
          this.initForm(this);
      } else {
          setTimeout(function() { defer ()  }, 50);
      }
    }
    this.refreshAfterSleep();
    defer();
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
  }

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  filterAvailableDates(obj, predicate){
    return Object.keys(obj)
        .filter( key => predicate(obj[key]) )
        .reduce( (res, key) => (res[key] = obj[key], res), {} );
  } 
  

  getArena(){
    const urlParams = new URLSearchParams(window.location.search);
    fetch(`${this.baseUrl}/pay/events/arena/details?arena_hash=${urlParams.get('id')}&booking_type=${urlParams.get('type')}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            if(!resp.data.available_days || (resp.data.available_days && !Object.keys(resp.data.available_days).length)){
                this.setState({
                    showNoBooking: true,
                    eventDays: resp.data.event_days
                })
            }
            let availableDates = this.filterAvailableDates(resp.data.available_days, bookings => bookings > 0);
            this.setState({ 
              address: resp.data.address,
              parkingId: resp.data.parking_id,
              availableDates: availableDates,
              bookingType: urlParams.get('type'),
              arenaHash: urlParams.get('id'),
              selectedDates: (urlParams.get('type') != 'advance' || (resp.data.available_days && Object.keys(resp.data.available_days).length === 1)) && 
                                resp.data.available_days && 
                                Object.keys(resp.data.available_days).length ? [Object.keys(resp.data.available_days)[0]] : []
            }, () => {
                if(this.state.selectedDates){
                    this.calculatePrice();
                }
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        });
  }

  calculatePrice(){
    const selection = this.state.selectedDates ? this.state.selectedDates.length : 0;
    if(!selection) {
        this.setState({ 
            parkingFee: null,
            convenienceFee: null,
            totalFee: null,
            surchargeFee: null,
            salesTaxFee: null,
            transactionFee: null
        })
        return;
    }
    fetch(`${this.baseUrl}/pay/events/slot/details?parking_id=${this.state.parkingId}&booking_type=${this.state.bookingType}&days_list=${this.state.selectedDates.join()}&arena_hash=${this.state.arenaHash}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({ 
              parkingFee: resp.data.parking_fee,
              convenienceFee: resp.data.convenience_fee,
              totalFee: resp.data.parking_charge,
              surchargeFee: resp.data.surcharge_fee,
              salesTaxFee: resp.data.sales_tax_fee,
              surchargeFeeTitle: resp.data.custom_surcharge_tax_field_name,
              salesTaxFeeTitle: resp.data.custom_sales_tax_field_name,
              transactionFee: resp.data.additional_transaction_fee
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            this.setState({ 
              parkingFee: null,
              convenienceFee: null,
              totalFee: null
            }, () => {
              toast.error(errMsg);
            })
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        });
   }

  getLotTZ(id){
    let timeZone = '';
    switch (id) {
      // san antonio
      case 5705:
        timeZone = 'US/Central';
        break;
      // miami  
      case 5706:
      case 5707:  
        timeZone = 'US/Eastern';
        break;
      default:
        break;
    }
    return timeZone;
  }

  handleAreaCode(areaCode){
    let fields = {...this.state.fields};
    fields['areaCode'] = areaCode;
    this.setState({ 
      fields 
    });
  }

  debounce(func, timeout = 500){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  handleChange(e) {
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value;
    if(e.target.name === 'hours' || e.target.name === 'mins'){
      this.setState({
        fields
      }, () => {
        this.setState({
          end: moment(this.state.start, 'MMM DD, YYYY, hh:mm A').add(this.state.fields['hours'], 'hours').add(this.state.fields['mins'], 'minutes').format('MMM DD, YYYY, hh:mm A')
        }, () => { if(this.state.fields['spot_no'] && this.state.fields['spot_no'].length) this.calculatePrice()});
      });
    }else{
      this.setState({
          fields
        });
    }
    
  }

  nonSpecialCharacter(name){
      let fields = this.state.fields;
      return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(fields[name]);
  }

  onlyZip(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]{5}$/)){
      return false;
    }
    return true;
  }

  onlyPhone(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]*$/)){
      return false;
    }
    return true;
  }

  onlyEmail(name){
    let fields = this.state.fields;
    if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
      return false;
    }
    return true;
  }

  initForm(_this){
    this.getArena();
    var stripe = window.Stripe(this.stripeKey);
    var elements = stripe.elements();

      var style = {
        base: {
          iconColor: '#666EE8',
          color: '#000',
          lineHeight: '40px',
          fontSize: '16px',
      
          '::placeholder': {
            color: '#000',
            fontWeight: 300,
            fontSize: '13px'
          },
        },
      };

      var card = elements.create('card', {style: style, hidePostalCode: false});

      card.mount('#card-element');

      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });

    function setOutcome(result) {
      const submitBtn = document.getElementById("pay-submit");
      if (result.source && result.source.id) {
        _this.handleSubmit(result.source.id, card);
      } else if (result.error) {
        _this.manageBodyBackground(false);
        _this.setState({loading : false});
        toast.error(result.error.message ? result.error.message : 'Something went wrong', { autoClose: 10000 });
        submitBtn.disabled = false;
      }
    }

    const validateForm = () => {
      let fields = this.state.fields;
      let formIsValid = true;
      this.errors = {};
      const cardWrapper = document.querySelector('#card-element');
      const cardWrapperError = document.querySelector('#card-errors');
      if (!fields["license_plate"] || (fields["license_plate"] && fields["license_plate"].trim() === '')) {
        formIsValid = false;
        this.errors["license_plate"] = "enter your license plate no.";
      }
      if (typeof fields["license_plate"] !== "undefined") {
        const isValid = this.nonSpecialCharacter("license_plate");
        if (!isValid) {
          formIsValid = false;
          this.errors["license_plate"] = "enter a valid license plate no.";
        }
      }
      if (!fields["mobile"] || (fields["mobile"] && fields["mobile"].trim() === '')) {
        formIsValid = false;
        this.errors["mobile"] = "enter your mobile no.";
      }
      if (typeof fields["mobile"] !== "undefined") {
        const isValid = this.onlyPhone("mobile");
        if (!isValid) {
          formIsValid = false;
          this.errors["mobile"] = "enter a valid mobile no.";
        }
      }

      if (!fields["email"] || (fields["email"] && fields["email"].trim() === '')) {
        formIsValid = false;
        this.errors["email"] = "enter your email address";
      }

      if (fields["email"] != '' && fields["email"].trim() != '') {
        const isValid = this.onlyEmail("email");
        if (!isValid) {
          formIsValid = false;
          this.errors["email"] = "enter a valid email address";
        }
      }
      if(cardWrapper.classList.contains('StripeElement--empty')){
        formIsValid = false;
        cardWrapperError.innerHTML = "enter your card number";
      }
      if(cardWrapper.classList.contains('StripeElement--invalid')){
        formIsValid = false;
        if(!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
      }
      if (!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === '')) {
        formIsValid = false;
        this.errors["cardholder_name"] = "enter the cardholder name";
      }

      this.setState({
        errors: this.errors
      });
      return formIsValid;
    }

    document.querySelector('form').addEventListener('submit', function(e) {
      e.preventDefault();
      document.getElementById("pay-submit").disabled =  true;
      if(_this.state.loading) return;
      const submitBtn = document.getElementById("pay-submit");
      if(!_this.state.selectedDates || !_this.state.selectedDates.length){
        toast.error('Please choose a date');
        submitBtn.disabled = false;
        return;
      }
      const isValid = validateForm();
      if(!isValid) {
        submitBtn.disabled = false;
        return;
      }
      if(!_this.state.totalFee){
        toast.error('Please enter valid spot no. & duration');
        submitBtn.disabled = false;
        return;
      }
      _this.manageBodyBackground(true);
      _this.setState({loading : true});
      const { fields } = _this.state;
      let contactNumber = fields.mobile ? fields.mobile.trim() : '';
      let countryCode = fields.areaCode ? '+' + fields.areaCode : '';
      var options = {
        name: fields.cardholder_name,
        phone: countryCode +' '+ contactNumber,
      };
      if(fields.email){
        options.email = fields.email ? fields.email.trim() : ''
      }
      stripe.createSource(card,{
        owner: options,
        statement_descriptor: "Parking reservation at " + _this.state.name
      }).then(setOutcome, _this);
    });
  }

  handleSubmit(id, card){
    const submitBtn = document.getElementById("pay-submit");
    const { fields } = this.state;
    const countryCodeName = countryCode.filter(item => item.id == fields.areaCode)[0]; 
    const request = {
      source_id: id,
      email: fields.email ? fields.email.trim() : '',
      contact_number: fields.mobile ? fields.mobile.trim() : '',
      country_code: fields.areaCode ? '+' + fields.areaCode : '',
      country_name: countryCodeName ? countryCodeName.name : '',
      vehicle_no: fields.license_plate ? fields.license_plate.toUpperCase().trim() : '',
      days_list: this.state.selectedDates,
      parking_arena_id: this.state.parkingId,
      booking_type: this.state.bookingType
    }
    fetch(`${this.baseUrl}/pay/events/parking/reserve`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          window.scrollTo(0,0);
          this.setState({...this.resetState, bookingID: resp.data.token}, () => {
            card.clear();
            // this.getArena();
            submitBtn.disabled = false;
            var checkboxes = document.getElementsByName('check');
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({loading : false});
          toast.error(errMsg, { autoClose: errMsg.length > 20 ? 10000 : 2000 });
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.manageBodyBackground(false);
        this.setState({loading : false});
        toast.error('Something went wrong');
        submitBtn.disabled = false;
      });  
  }

  find(search, keys){
    if(!search) {
      return {
        "id": "1",
        "name": "US",
        "displayText": "United States (+1)",
        "country": "United States",
        "locale": "",
        "flag": `${URL.S3_BUCKET2}/FlagKit/US.imageset/US.png`
      }
    }
    var lowSearch = search.toLowerCase();
    return countryCode.filter(function(item){
        return keys.some( key => 
            String(item[key]).toLowerCase().includes(lowSearch) 
        );
    });
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  handleFocusSp(name){
    document.querySelector(`select[name="${name}"]`).focus();
    return false;
  }

  handleClose(){
    this.setState({booked: false, bookedID: null }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleSeeMore(){
    this.setState({seeMore: !this.state.seeMore }, () => {
      this.manageBodyBackground(this.state.seeMore);
    })
  }

  handleEventDates(e){
    let value = e.target.value;  
    if(e.target.checked){
        if(this.state.selectedDates.includes(value)) return;
        this.setState({
            selectedDates: [
                ...this.state.selectedDates,
                value
            ]
        }, () => this.calculatePrice())
    }else{
        this.setState({
            selectedDates: this.state.selectedDates.filter(item => item != value)
        }, () => this.calculatePrice())
    }
  }

  getReservedDates(){
    if(!this.state.selectedDates || !this.state.selectedDates.length) return [];
    let listOfDates = [], finalListOfDates = [];
    this.state.selectedDates.map(item => {
        let fDate = moment(item, "YYYY-MM-DD");
        listOfDates.push(fDate);
    })
    let sortedListOfDates = listOfDates.sort((a, b) => a.unix() - b.unix());
    sortedListOfDates.map(item => {
        let fDate = item.format("DD-MMM-yyyy");
        finalListOfDates.push(fDate);
    })
    return finalListOfDates.join(', ');
  }

  calculateNetAmount(){
    const parkingFee = this.state.parkingFee || 0;
    const salesTaxFee = this.state.salesTaxFee || 0;
    const surchargeFee = this.state.surchargeFee || 0;
    const discountAmount = this.state.discountAmount || 0;
    let net = (parkingFee + salesTaxFee + surchargeFee) - discountAmount;
    if(net < 0) net = 0;
    return !net ? '' : `$${(net/100).toFixed(2)}`;
  }

  calculateConvenienceFee(){
    const parkingFee = this.state.parkingFee || 0;
    const convenienceFee = this.state.convenienceFee || 0;
    const transactionFee = this.state.transactionFee || 0;
    let conv = convenienceFee + transactionFee;
    if(conv < 0) conv = 0;
    return !parkingFee ? '' : `$${(conv/100).toFixed(2)}`;
  }

  removeSecondBrackets(input){
    if (!input) {
        return input;
    }
    const regex = /(.*?\(.*?\))(.*?\(.*?\))/;
    const result = input.replace(regex, '$1');
    return result;
  }

  render() {
    return (
      <div style={{position: 'relative'}}>
        {this.state.loading && <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10}}></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        <div style={{display: this.state.showNoBooking ? 'block' : 'none'}} className="success-message">
          <div style={{textAlign: 'center'}}>
            <img style={{height: 55}} src={notAllowed} /> 
          </div>
          <h3 style={{color: '#000', padding: '0 10px', fontSize: '15px'}} className="success-message__title">Bookings are only available for these dates: {this.state.eventDays && this.state.eventDays.map((item, index) =>  index < (this.state.eventDays.length - 1) ? moment(item, "YYYY-MM-DD").format("DD-MMM-yyyy") + ", " : moment(item, "YYYY-MM-DD").format("DD-MMM-yyyy"))}</h3>
        </div> 
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span> 
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Booked Successfully</h3>
          <div className="success-message__content">
              <p>You will receive an email from us which will need to be shown as the proof of payment at the time of parking.</p>
              <p style={{marginTop: '5px'}}>Booking Id: {this.state.bookingID}</p>
          </div>
        </div>
        {this.state.seeMore && this.state.arenaDetails && <div className="lot-details">
          <span onClick={this.handleSeeMore.bind(this)} id="sm-close">&times;</span>
          <LotDetails details={this.state.arenaDetails} />
        </div>}
        <form style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto', opacity: this.state.showNoBooking ? 0.25 : 1}} action="#" method="POST">
          <input type="hidden" name="token" />
          <div style={{textAlign: 'center', paddingBottom: 20}}>
            <img style={{height: '100px'}} src={logoImg} />
          </div>
          <div style={{textAlign: 'center'}} className="location event-location">
            <img style={{height: 35}} src={gpsIcon} /> 
            <span>{this.state.address}</span>
          </div>
          <div className="advance-dates">
              {Object.keys(this.state.availableDates).map((key, index) => {
                  let fDate = moment(key, "YYYY-MM-DD").format("DD-MMM-yyyy"); 
                  let isSelected = false;
                  if(this.state.selectedDates && this.state.selectedDates.length){
                    isSelected = this.state.selectedDates.includes(key);
                  }
                  return(
                    <>
                        <input value={key} checked={isSelected} name="check" onChange={this.handleEventDates.bind(this)} id={`date-selection${index}`} type="checkbox" />
                        <label htmlFor={`date-selection${index}`}>
                            {fDate}
                        </label>
                    </>
                  )
              })}   
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('license_plate')}>To get started, please tell us the license plate no. <i>*</i></span>
            <input
              className="pay-fields" 
              style={{textTransform: 'uppercase'}}
              value={this.state.fields["license_plate"]}
              name="license_plate"
              onChange={this.handleChange}
              maxLength={10}
            />
            <div style={{fontSize: '11px', color: '#afafaf'}}>Inaccurate License Plate number will result in  monetary fine.</div>
            <div className="error-msg">{this.state.errors['license_plate']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('email')}>Next, provide your email address. We will send you the receipt. <i>*</i></span>
            <input
              className="pay-fields" 
              value={this.state.fields["email"]}
              name="email"
              onChange={this.handleChange}
              maxLength={150}
            />
            <div className="error-msg">{this.state.errors['email']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('mobile')}>Enter your mobile no. to get updates <i>*</i></span>
            <div className="country-with-phone">
              <div className="country-code">
                  <ReactCustomFlagSelect
                    showSearch={false} 
                    showArrow={true} 
                    animate={true} 
                    value={this.state.fields['areaCode']}
                    customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                    optionList={countryCode} 
                    onChange={areaCode => {
                      this.handleAreaCode(areaCode);
                    }}
                    
                  />
              </div>
              <div className="input-wrapper">
                  <input
                    className="pay-fields mobile-input" 
                    value={this.state.fields["mobile"]}
                    name="mobile"
                    onChange={this.handleChange}
                    maxLength={15}
                  />
              </div>
              <div style={{clear: 'both'}}></div>
            </div>
            <div className="error-msg">{this.state.errors['mobile']}</div>
          </div>
          <h4 style={{paddingTop: 10, paddingBottom: 10}}>Reservation Summary</h4>
          <ul className="pay-timings">
            <li>
              <span className="list-initial">Reservation period</span>
              <span>{this.getReservedDates()}</span>
            </li>
            <li>
              <span className="list-initial">Parking fee</span>
              <span>{this.state.parkingFee > 0 ? `$${(this.state.parkingFee/100).toFixed(2)}` : ''}</span>
            </li>
            {this.state.surchargeFee > 0 && <li>
              <span className="list-initial">{this.removeSecondBrackets(this.state.surchargeFeeTitle)}</span>
              <span>{`$${(this.state.surchargeFee/100).toFixed(2)}`}</span>
            </li>}
            {this.state.salesTaxFee > 0 && <li>
              <span className="list-initial">{this.removeSecondBrackets(this.state.salesTaxFeeTitle)}</span>
              <span>{`$${(this.state.salesTaxFee/100).toFixed(2)}`}</span>
            </li>}
            <li>
              <span className="list-initial">Net amount</span>
              <span>{this.calculateNetAmount()}</span>
            </li>
            <li>
              <span className="list-initial">Convenience fee</span>
              <span>{this.calculateConvenienceFee()}</span>
            </li>
            <li>
              <span className="list-initial">Total fee</span>
              <span style={{fontWeight: 600, fontSize: '18px'}}>{this.state.totalFee > 0 ? `$${(this.state.totalFee/100).toFixed(2)}` : ''}</span>
            </li>
          </ul>
          <p style={{padding: '10px 0', fontWeight: 600, fontSize: '12px'}}>There is no in and out privilege.</p>
          <h4>Payment</h4>
          <h6>Card Information</h6>
          <div className="card-info">
            <div id="card-element">
            </div>
          </div>
          <div className="error-msg" id="card-errors" role="alert"></div>
          <div class="group">
            <label>
              <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
            </label>
          </div>    
          <div style={{paddingLeft: '15px', marginTop: '4px'}} className="error-msg">{this.state.errors['cardholder_name']}</div>  
          <button id="pay-submit" type="submit">Pay {this.state.totalFee > 0 ? `$${(this.state.totalFee/100).toFixed(2)}` : ''}</button>
          <div style={{clear: 'both'}} />
          <div className="outcome">
            <div className="error" />
            <div className="success">
              Success! Your Stripe token is <span className="token" />
            </div>
          </div>
          <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
        </form>
      </div>      
    )
  }
}
